import "core-js/modules/es.array.slice.js";
import React from 'react';
import { useTranslation } from 'react-i18next';
import Box from 'components/Box';
import Button from 'components/Button';
import EmptyStateController from 'components/EmptyStateController';
import StatsList from 'components/StatsList';
import StatsWrapper from './StatsWrapper';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function InlineStatsPanel(_ref) {
  var isLoading = _ref.isLoading,
    isError = _ref.isError,
    _ref$isPanelLayout = _ref.isPanelLayout,
    isPanelLayout = _ref$isPanelLayout === void 0 ? false : _ref$isPanelLayout,
    title = _ref.title,
    _ref$data = _ref.data,
    data = _ref$data === void 0 ? [] : _ref$data,
    handleViewAll = _ref.handleViewAll,
    onClick = _ref.onClick;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var actions;
  if (data.length) {
    actions = /*#__PURE__*/_jsx(Button, {
      size: isPanelLayout ? 'small' : 'medium',
      variant: isPanelLayout ? 'transparent' : 'default',
      iconRight: isPanelLayout ? 'hierarchy' : undefined,
      onClick: onClick,
      children: t('actions_view_all')
    });
  }
  return /*#__PURE__*/_jsxs(StatsWrapper, {
    actions: actions,
    title: title,
    isPanelLayout: isPanelLayout,
    children: [/*#__PURE__*/_jsx(EmptyStateController, {
      isLoading: isLoading,
      isEmpty: !data.length,
      isError: isError,
      children: /*#__PURE__*/_jsx(StatsList, {
        data: data.slice(0, 5)
      })
    }), handleViewAll && /*#__PURE__*/_jsx(Box, {
      textAlign: "center",
      mb: -12,
      children: /*#__PURE__*/_jsx(Button, {
        size: "medium",
        variant: "transparent",
        onClick: handleViewAll,
        children: t('actions_view_all')
      })
    })]
  });
}
export default InlineStatsPanel;
export { default as StatsWrapper } from './StatsWrapper';
export { default as AssetPopularUsersStats } from './AssetPopularUsersStats';
export { default as AssetActivityLog } from './AssetActivityLog';
export { default as PopularAssetInFolderOrPlaylistStats } from './PopularAssetInFolderOrPlaylistStats';
export { default as PlaylistRecentUsersStats } from './PlaylistRecentUsersStats';